import ReactDOM from "react-dom";
import { HelmetProvider } from "react-helmet-async";
import { BrowserRouter } from "react-router-dom";
import ScrollTop from "src/hooks/useScrollTop";

import "nprogress/nprogress.css";
import { Provider } from "react-redux";
import App from "src/App";
import { Auth0ProviderWithNavigate } from "src/contexts/Auth0";
import { SidebarProvider } from "src/contexts/SidebarContext";
import * as serviceWorker from "src/serviceWorker";
import store from "src/store";
import "./styles/index.css";
import { AppProvider } from "./utils/AppContextUtils";
import ErrorBoundary from "./components/ErrorBoundary/ErrorBoundary";
import { PermissionProvider } from "./utils/PermissionProvider";
// import { IdleProvider } from "./utils/IdleProvider";
import "./index.css";
import { IdleHandleProvider } from "./utils/IdleHandleProvider";

ReactDOM.render(
  <HelmetProvider>
    <AppProvider>
      <Provider store={store}>
        <SidebarProvider>
          <BrowserRouter>
            <ScrollTop />
            <Auth0ProviderWithNavigate>
              <ErrorBoundary>
                <IdleHandleProvider>
                  <PermissionProvider>                    
                    <App />                    
                  </PermissionProvider>
                </IdleHandleProvider>
              </ErrorBoundary>
            </Auth0ProviderWithNavigate>
          </BrowserRouter>
        </SidebarProvider>
      </Provider>
    </AppProvider>
  </HelmetProvider>,
  document.getElementById("root")
);

serviceWorker.unregister();
